import _ from 'lodash';
import { NAVIGATION } from '../config';
import { Action } from '../redux/redux.types';
import { RouterState } from '../types/router';
import { ROUTER_ACTION_NAMES } from './router.actions';

const defaultState: any = {};

export const router = (
  state = defaultState,
  { type, payload }: Action,
): RouterState => {
  switch (type) {
    case ROUTER_ACTION_NAMES.SHOW: {
      const pageName = _.findKey(NAVIGATION, (path) => path === payload.path);
      return {
        currentPageName: (pageName || '').toLowerCase(),
        previousPage: _.get(state, 'context.path', ''),
        path: payload.path,
        context: payload.context,
        error: payload.error,
      };
    }

    default:
      return state;
  }
};
